import React,{useMemo}from'react';
import * as FiIcons from'react-icons/fi';
import SafeIcon from'../common/SafeIcon';
import DashboardActivity from'./DashboardActivity';
import DashboardBookedEvents from'./DashboardBookedEvents';
import DashboardFollowUp from'./DashboardFollowUp';
import PreEventConsultation from'./PreEventConsultation';
import{getSubmissionQueue}from'../utils/submissionQueue';
import'./admin-dashboard.css';

const{FiCalendar,FiSend,FiUsers}=FiIcons;

function parseLocalDate(value){
  const match=String(value||'').match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if(match)return new Date(Number(match[1]),Number(match[2])-1,Number(match[3]));
  const date=new Date(value);
  return Number.isNaN(date.getTime())?null:new Date(date.getFullYear(),date.getMonth(),date.getDate());
}

function formatDate(value){
  const date=parseLocalDate(value);
  return date?`${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')}-${String(date.getFullYear()).slice(-2)}`:value||'—';
}

function AdminHome({events,openEvent,onOpenEvents}){
  const submissions=useMemo(
    ()=>getSubmissionQueue(events),
    [events]
  );

  const readyForReview=submissions.filter(
    (submission)=>submission.status==='Ready for review'
  );
  const today=new Date();
  today.setHours(0,0,0,0);
  const weekEnd=new Date(today);
  weekEnd.setDate(weekEnd.getDate()+7);
  const eventsThisWeek=events.filter((event)=>{
    const date=parseLocalDate(event.date);
    return date&&date>=today&&date<weekEnd;
  });
  const waitingOnClient=events.filter((event)=>
    Number(event.completion||0)<100&&
    event.status!=='Approved'&&
    event.status!=='Completed'&&
    (event.shareToken||event.status==='In Progress')
  );
  const nextEvents=[...events]
    .filter((event)=>{
      const date=parseLocalDate(event.date);
      return !date||date>=today;
    })
    .sort((first,second)=>
      (parseLocalDate(first.date)?.getTime()??Number.MAX_SAFE_INTEGER)-
      (parseLocalDate(second.date)?.getTime()??Number.MAX_SAFE_INTEGER)
    )
    .slice(0,5);

  return <main className="main-content dashboard-home">
    <div className="page-heading">
      <div>
        <span className="eyebrow">Workspace overview</span>
        <h1>Good morning,Asi</h1>
        <p>
          Here is what needs your attention today.
        </p>
      </div>
      <button
        type="button"
        className="button secondary"
        onClick={onOpenEvents}
      >
        View all events
      </button>
    </div>

    <section className="metric-grid">
      <article>
        <SafeIcon icon={FiCalendar}/>
        <span>
          <strong>{eventsThisWeek.length}</strong>
          <small>Events this week</small>
        </span>
      </article>
      <article>
        <SafeIcon icon={FiUsers}/>
        <span>
          <strong>{readyForReview.length}</strong>
          <small>Answers to review</small>
        </span>
      </article>
      <article>
        <SafeIcon icon={FiSend}/>
        <span>
          <strong>{waitingOnClient.length}</strong>
          <small>Waiting on client</small>
        </span>
      </article>
    </section>

    <section className="panel next-up-panel">
      <div className="panel-header">
        <div><h2>Next up</h2><p>Your next five events, in date order.</p></div>
      </div>
      {nextEvents.length===0
        ?<div className="events-empty"><strong>No upcoming events</strong><span>Create an event to see it here.</span></div>
        :<div className="next-up-list">
          {nextEvents.map((event)=>{
            const date=parseLocalDate(event.date);
            const days=date?Math.round((date.getTime()-today.getTime())/86400000):null;
            return <article className="next-up-row" key={event.id}>
              <div className="next-up-date">
                <strong>{formatDate(event.date)}</strong>
                <small>{days===null?'Date pending':days===0?'Today':`${days} days`}</small>
              </div>
              <div className="next-up-event">
                <strong>{event.name}</strong>
                <span>{event.client} · DJ {event.dj||'TBD'}</span>
              </div>
              <button type="button" className="button secondary" onClick={()=>openEvent(event)}>
                {event.completion>0?'Review event':'Open event'}
              </button>
            </article>;
          })}
        </div>}
    </section>
  </main>;
}

export default AdminHome;